/**
 * Global frontend error monitor. Captures unhandled JS errors and
 * unhandled promise rejections and forwards them to the backend.
 * Throttles to avoid flooding (max 1 error/3s per signature).
 */

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const SENT = new Map(); // signature -> timestamp
const THROTTLE_MS = 3000;

const send = (payload) => {
  const sig = (payload.message || '').slice(0, 200);
  const now = Date.now();
  const last = SENT.get(sig);
  if (last && now - last < THROTTLE_MS) return;
  SENT.set(sig, now);

  try {
    const token = localStorage.getItem('token');
    fetch(`${BACKEND}/api/client-errors`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({
        message: (payload.message || 'Unknown error').slice(0, 2000),
        stack: (payload.stack || '').slice(0, 10000),
        url: window.location.href,
        user_agent: navigator.userAgent,
        severity: payload.severity || 'error',
      }),
      keepalive: true, // survives unload
    }).catch(() => {});
  } catch {
    // never throw from the error reporter itself
  }
};

export function installErrorMonitor() {
  // Unhandled exceptions
  window.addEventListener('error', (e) => {
    send({
      message: `${e.message} (${e.filename}:${e.lineno}:${e.colno})`,
      stack: e.error?.stack,
    });
  });

  // Unhandled promise rejections
  window.addEventListener('unhandledrejection', (e) => {
    const reason = e.reason || {};
    send({
      message: `Unhandled promise: ${reason.message || String(reason)}`,
      stack: reason.stack,
    });
  });
}
